import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../shared/shared.service';
import { API_MODULES } from '../../../core/api-modules';

@Component({
  selector: 'app-recipe-details',
  templateUrl: './recipe-details.component.html',
  styleUrls: ['./recipe-details.component.scss']
})
export class RecipeDetailsComponent implements OnInit {

  recipe: any = null;
  loading: boolean = false;
  
  ingredientsList: string[] = [];
  preparationSteps: string[] = [];

  constructor(
    private route: ActivatedRoute,
    private api: SharedService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.params['id'];
    this.loadRecipeDetails(id);
  }

  async loadRecipeDetails(slugs: string): Promise<void> {
    try {
      this.loading = true;
      const res: any = await this.api.getBySlugs(API_MODULES.RECIPE, slugs);

      if (res?.status === 'success') {
        this.recipe = res.data;

        // Convert {{item}}{{item}} into array
        this.ingredientsList = this.parseDoubleBrackets(res.data.ingredients);
        this.preparationSteps = this.parseDoubleBrackets(res.data.preparation);
      }

    } catch (err) {
      console.error("Error loading recipe:", err);
    } finally {
      this.loading = false;
    }
  }

  parseDoubleBrackets(str: string): string[] {
    if (!str) return [];
    return str.replace(/{{/g, '')
              .replace(/}}/g, '|')
              .split('|')
              .filter(x => x.trim() !== '');
  }

  getImg(path: string): string {
    if (!path) return 'assets/no-image.png';
    if (path.startsWith('http')) return path;
    return this.api.imageBase + path;
  }

  getBgDesktop(): string {
    return this.recipe ? `url("${this.getImg(this.recipe.d_image)}")` : 'none';
  }

  getBgMobile(): string {
    return this.recipe ? `url("${this.getImg(this.recipe.m_image)}")` : 'none';
  }
}
